import { useStore } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useUpdateRegistration } from '../../../../../registration/useRegistrationForm/useUpdateRegistration';
import { OppvarmingFormData } from '../../types';
import { fromOppvarmingFormDataToUserInput } from '../dataMapper';
import { SubmitPayload } from '../../../../components/formBackButton';

export const useOppvarmingSubmit = () => {
  const params = useParams();
  const { updateRegistration, updateIsLoading, updateError } = useUpdateRegistration(params.registrationId);
  const store = useStore();
  const userInput = store.getState().register.userInput;

  const onOppvarmingSubmit = ({ data, onSuccess }: SubmitPayload<OppvarmingFormData>) => {
    // Transform form data to UserInput
    const updatedUserInput = fromOppvarmingFormDataToUserInput(data, userInput);

    updateRegistration(
      { registrationId: params.registrationId, userInput: updatedUserInput },
      {
        onSuccess
      }
    );
  };
  return { onOppvarmingSubmit, isLoading: updateIsLoading, updateError };
};
